const prefill = ({ session, product = {}, address = {} }) => {
  if ( !session ) return
  setField( "firm[customernr]", session.value.map_id )
  setField( "firm[name]", session.value.title )
  setField( "person[firstname]", address.name2 )
  setField( "person[lastname]", address.name3 )
  setField( "address[street]", address.street )
  setField( "address[postcode]", address.pcode )
  setField( "address[city]", address.city )
  setField( "content[subject]", "" )
  setField( "contact[email]", address.email )
  setField( "contact[phone]", address.phone )

  setOption( "person[salutation]", address.name1 )
  // setField( "extra[catalog]", session.value.map_id )
  // setField( "extra[sendbills]", session.value.map_id )
}

const setField = (selector, value) => {
  let field = document.querySelector( `input[name='${selector}']` )
  if ( field ) field.value = value
}

const setOption = (selector, value) => {
  let field = document.querySelector( `select[name='person[salutation]']` )
  if ( field ) field.value = value
}

export default prefill



// WEBPACK FOOTER //
// ./src/theme/mags/components/Form/prefill.js